import { Hidden as Mui5Hidden } from '@mui/material'

export const Hidden = Mui5Hidden
